import { createAxiosClient } from '../axiosDefaults';
const CONSUMER_CARLEAD_PATH = 'consumer/';
export function createApi(baseUrl, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const instance = createAxiosClient({
    baseURL: baseUrl + "/" + CONSUMER_CARLEAD_PATH,
    withCredentials: true,
    ...axiosConfig
  }, config);

  function getConsumerCarlead(carleadHash) {
    return instance.get("carlead/" + carleadHash);
  }

  function getConsumerSelfEvaluation(carleadHash) {
    return instance.get("self-evaluation/" + carleadHash);
  }

  function getConsumerCarleadPrices(carleadHash) {
    return instance.get("carlead/" + carleadHash + "/aux-prices");
  }

  function getConsumerCarleadPriced(carleadHash) {
    return instance.head("carlead/" + carleadHash + "/price");
  }

  function getCarleadObfuscation(carleadHash) {
    return instance.get("carlead-obfuscation/" + carleadHash);
  }

  function patchConsumerCarlead(carleadHash, data) {
    return instance.patch("carlead/" + carleadHash, data, {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    });
  }

  function createCarlead(payload) {
    return instance.post('carlead', payload);
  }

  function createCarleadLicensePlate(payload) {
    return instance.post('carlead/licenseplate', payload);
  }

  function createExpectedPrice(hash, expectedPrice) {
    return instance.post("expected-price/" + hash, {
      expectedPrice
    }).then(response => {
      return response.data;
    });
  }

  return {
    getConsumerCarlead,
    getConsumerCarleadPrices,
    getConsumerCarleadPriced,
    getCarleadObfuscation,
    getConsumerSelfEvaluation,
    patchConsumerCarlead,
    createCarlead,
    createCarleadLicensePlate,
    createExpectedPrice
  };
}